// src/app/auth/auth.service.ts
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {MandantenService} from '../mandanten/mandanten.service';
import {MitteilungsService} from '../prozesse/mitteilung.service';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class SMTPGuard {

  public environment = environment

  constructor(
    private router: Router,
    private mandant_service: MandantenService,
    public mitteilungen_service: MitteilungsService,
  ) {
  }

  canActivate(): Observable<boolean> {
    return this.mandant_service.mandant_get().pipe(
      map(mandant => {
        if (!mandant.mailerAktiv) {
          if (environment.type !== 'web'){
            this.mitteilungen_service.set_snackbar('1019', 5000);
          } else {
            this.mitteilungen_service.setMitteilung('1019');
          }
          return false;
        }
        return true;
      }),
      catchError(() => {
        if (environment.type !== 'web'){
          this.mitteilungen_service.set_snackbar('1019', 5000);
        } else {
          this.mitteilungen_service.setMitteilung('1019');
        }
        return [false];
      })
    );
  }
}
